"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneFromTemplateArtifact = void 0;
const cloneUtils_1 = require("../cloneUtils");
// @makarand-clone: This is marked unsupported because this node references
// `org_provided_inputs` table, we need to clone entries from that table to be able
// to clone this.
exports.cloneFromTemplateArtifact = cloneUtils_1.unSupportedClone;
//# sourceMappingURL=clone.js.map